import NavigationContext from '@/layout/side-nav/context';
import React, { useContext } from 'react';
import { Menu01 } from '@kula-ai/icons-core';
import { Flex, Image, Text } from '@chakra-ui/react';
import kulaLogo from '@/assets/icons/Logo.svg';

export const SideNavControl = () => {
  const { isNavCollapsed, handleNavCollapse } = useContext(NavigationContext);

  const handleMenuClick = () => {
    handleNavCollapse(!isNavCollapsed);
  };

  return (
    <Flex alignItems="center" gap="6px">
      <Menu01
        size="1em"
        color="#FFF"
        className="kula-icon"
        style={{ cursor: 'pointer' }}
        onClick={handleMenuClick}
      />
      <Image src={kulaLogo} width="1em" height="1em" ml="10px" />
      <Text size="md-semi-bold" color="#fff">
        kula
      </Text>
    </Flex>
  );
};
